export enum IrisApiStatus {
    IRIS_AD_RECEIVED = "IrisAdReceived",
    IRIS_NO_AD_RECEIVED = "IrisNoAdReceived",
    NO_IRIS_RESPONSE_RECEIVED = "NoIrisResponseReceived"
}
